import createReducer from '../createReducer';
import {
  FETCH_LATEST_OPPORTUNITIES,
  FETCH_LATEST_OPPORTUNITIES_SUCCESS,
  UPDATE_LATEST_OPPORTUNITIES,
  UPDATE_LATEST_OPPORTUNITIES_SUCCESS,
} from '../actions/opportunity';

export const initialState = {
  loadingLatestOpportunities: false,
  latestOpportunities: null,
  savingLatestOpportunities: false,
};

export default createReducer(initialState, {
  [FETCH_LATEST_OPPORTUNITIES]: draft => {
    draft.loadingLatestOpportunities = true;
  },

  [FETCH_LATEST_OPPORTUNITIES_SUCCESS]: (draft, action) => {
    draft.loadingLatestOpportunities = false;
    draft.latestOpportunities = action.latestOpportunities;
  },

  [UPDATE_LATEST_OPPORTUNITIES]: (draft, action) => {
    draft.savingLatestOpportunities = true;
    draft.latestOpportunities = action.latestOpportunities;
  },

  [UPDATE_LATEST_OPPORTUNITIES_SUCCESS]: draft => {
    draft.savingLatestOpportunities = false;
  },
});
